import { Box } from '@material-ui/core';
import _isEmpty from 'lodash/isEmpty';
import { TextErr } from 'component/customize_style_component/styled_title';
import CustomizeLayoutQuiz from 'component/layout_quiz/layout_quiz';
import { useEffect, useState } from 'react';
import Pear from '../../../assets/img/Pear.png';
import BodyItem from './item_body_shape_body_type';
import { useStyles } from './styles';
import EmptyAnswer from 'component/StandardAlert/no_answer';
import { PATH } from 'routes/constant';
import { useLocation } from 'react-router-dom';
import { EQuizId, quizContextType } from 'types/quiz';
import ScrollContainer from 'react-indiana-drag-scroll';
import useValidateAnswers from '../hooks/useValidateAnswers';
interface IBodyShapeBodyTypeProps {
    listData: any[];
    handleClickAnswer: (input) => void;
    questionId: string;
    questionSubject: string;
    title: string;
    isUpdate: boolean;
    isDisplayContent: boolean;
    titlePage: string;
    defaultValue?: any;
    requiredQuestion?: boolean;
    userName?: string;
    loadingAnswer: boolean;
    quizId: EQuizId;
    containerLoading?: boolean;
    completeQuizProcess?: () => void;
}
interface IBodyShapeBodyTypeOption {
    id?: string;
    label?: string;
    name?: string;
    value?: string;
}
const BodyShapeBodyTypeContainer = ({
    defaultValue,
    listData,
    questionId,
    questionSubject,
    handleClickAnswer,
    title,
    isUpdate,
    isDisplayContent,
    titlePage,
    requiredQuestion,
    userName,
    loadingAnswer,
    containerLoading,
    quizId,
    completeQuizProcess,
}: IBodyShapeBodyTypeProps) => {
    const location = useLocation();
    const classes = useStyles();
    const [error, setError] = useState(false);
    const [data, setData] = useState(listData);
    const [selectedOption, setSelectedOption] = useState<IBodyShapeBodyTypeOption>({});
    const [answerAlreadyUpdated, setAnswerUpdated] = useState(false);
    const isValidAnswer = useValidateAnswers(
        isUpdate,
        data?.find((item) => item.isSelect),
        answerAlreadyUpdated,
    );

    useEffect(() => {
        if (listData && listData.length > 0) {
            const temp = [...listData];
            setData(
                temp.map((d) => {
                    if (d.value.toLowerCase() === selectedOption?.value?.toLowerCase() && d.imageUrl) {
                        return {
                            ...d,
                            isSelect: true,
                        };
                    } else if (
                        d.value.toLowerCase() === defaultValue?.toLowerCase() &&
                        d.imageUrl &&
                        _isEmpty(selectedOption)
                    ) {
                        return {
                            ...d,
                            isSelect: true,
                        };
                    } else {
                        return {
                            ...d,
                            isSelect: false,
                        };
                    }
                }),
            );
        }
    }, [defaultValue, isDisplayContent, listData, location.pathname, selectedOption]);

    const handleClick = (item) => {
        setAnswerUpdated(true);
        if (isDisplayContent) {
            setSelectedOption(item);
            setData(
                data.map((d) => {
                    if (item.id === d.id) {
                        d.isSelect = true;
                    } else {
                        d.isSelect = false;
                    }
                    return d;
                }),
            );
            setError(false);
        }
    };
    const input = {
        questionId: questionId,
        questionSubject: questionSubject,
        contextType: quizContextType,
        contextId: quizId,
        valueType: 'STRING',
    };
    const handleAnswer = () => {
        const option = data.find((item) => item.isSelect);
        if (option) {
            handleClickAnswer({ ...input, value: option.value });
        } else {
            setError(true);
        }
    };
    const handleSkip = () => {
        handleClickAnswer({ ...input, value: '', isSkipped: true });
    };

    const getGridRepeat = () => {
        if (window.innerHeight < 690) {
            return data?.length;
        }
        return Math.ceil(data?.length / 2);
    };

    return (
        <CustomizeLayoutQuiz
            quizId={quizId}
            title={title}
            titlePage={titlePage}
            handleAnswer={handleAnswer}
            isUpdate={isUpdate}
            isDisplayContent={isDisplayContent}
            hideBottomNav={location.pathname === PATH.QUIZ_MANAGER}
            requiredQuestion={requiredQuestion}
            handleSkipQuestion={handleSkip}
            loading={loadingAnswer}
            containerLoading={containerLoading}
            nextBtnDisabled={!isValidAnswer}
            completeQuizProcess={completeQuizProcess}
        >
            <Box display={'flex'} flexDirection={'column'} height="100%" width="97%" overflow="scroll">
                <ScrollContainer
                    style={{
                        gridTemplateColumns: `repeat(${getGridRepeat()}, 45%)`,
                        margin: '12px',
                        marginTop: 'auto',
                        marginBottom: 'auto',
                        overflowX: 'scroll',
                        overflowY: 'hidden',
                    }}
                    className={isDisplayContent ? classes.gridQuiz : classes.quiz}
                >
                    {data.map((item, index) => (
                        <BodyItem
                            key={index}
                            imageUrl={item.imageUrl || Pear}
                            label={item.label}
                            isSelect={item.isSelect}
                            handleClick={() => handleClick(item)}
                            isDisplayContent={isDisplayContent}
                        />
                    ))}
                </ScrollContainer>
                {!defaultValue && !isDisplayContent && <EmptyAnswer title={titlePage} userName={userName} />}
                <Box height={'5%'} maxHeight={20} width="100%" position="fixed" minWidth={'100%'}>
                    <Box textAlign={'center'}>{error && <TextErr>Please select one option</TextErr>}</Box>
                </Box>
            </Box>
        </CustomizeLayoutQuiz>
    );
};
export default BodyShapeBodyTypeContainer;
